import React, { useEffect } from 'react'

const GpAddressForm = ({ manualDetails, setManualDetails }) => {

  return (
    <div className="mt-4">
      {/* GP Surgery Name */}
      <h2 className="text-lg font-semibold my-2">
        GP Surgery Name <span className="text-red-600"> *</span>
      </h2>
      <div className="mt-2 rounded-md bg-white px-4 py-3 text-base text-gray-900 border border-gray-300 placeholder:text-gray-400 focus-within:border-violet-300 focus-within:ring-1 focus-within:ring-violet-300 sm:text-sm">
        <input
          type="text"
          placeholder="GP Surgery Name"
          className="w-full focus:outline-none"
          value={manualDetails?.name}
          onChange={(e) =>
            setManualDetails({ ...manualDetails, name: e.target.value })
          }
        />
      </div>

      {/* GP Surgery Address */}
      <h2 className="text-lg font-semibold mb-2 mt-6">
        GP Surgery Address <span className="text-red-600"> *</span>
      </h2>
      <div className="mt-2 rounded-md bg-white px-4 py-3 text-base text-gray-900 border border-gray-300 placeholder:text-gray-400 focus-within:border-violet-300 focus-within:ring-1 focus-within:ring-violet-300 sm:text-sm">
        <input
          type="text"
          placeholder="Address line 1"
          className="w-full focus:outline-none"
          value={manualDetails?.addressLine1}
          onChange={(e) =>
            setManualDetails({ ...manualDetails, addressLine1: e.target.value })
          }
        />
      </div>
      <div className="mt-2 rounded-md bg-white px-4 py-3 text-base text-gray-900 border border-gray-300 placeholder:text-gray-400 focus-within:border-violet-300 focus-within:ring-1 focus-within:ring-violet-300 sm:text-sm">
        <input
          type="text"
          placeholder="Address line 2"
          className="w-full focus:outline-none"
          value={manualDetails?.addressLine2}
          onChange={(e) =>
            setManualDetails({ ...manualDetails, addressLine2: e.target.value })
          }
        />
      </div>

      <div className="flex mt-2 space-x-4">
        <input
          type="text"
          placeholder="City"
          className="flex-1 rounded-md bg-white px-4 py-3 text-base text-gray-900 border border-gray-300 placeholder:text-gray-400 focus-within:border-violet-300 focus-within:ring-1 focus-within:ring-violet-300 focus:outline-none sm:text-sm"
          value={manualDetails?.city}
          onChange={(e) =>
            setManualDetails({ ...manualDetails, city: e.target.value })
          }
        />
        <input
          type="text"
          placeholder="Postcode"
          className="flex-1 rounded-md bg-white px-4 py-3 text-base text-gray-900 border border-gray-300 placeholder:text-gray-400 focus-within:border-violet-300 focus-within:ring-1 focus-within:ring-violet-300 focus:outline-none sm:text-sm"
          value={manualDetails?.postcode}
          onChange={(e) =>
            setManualDetails({ ...manualDetails, postcode: e.target.value })
          }
        />
        <input
          type="text"
          placeholder="Country"
          className="flex-1 rounded-md bg-white px-4 py-3 text-base text-gray-900 border border-gray-300 placeholder:text-gray-400 focus-within:border-violet-300 focus-within:ring-1 focus-within:ring-violet-300 focus:outline-none sm:text-sm"
          value={manualDetails?.country}
          onChange={(e) =>
            setManualDetails({ ...manualDetails, country: e.target.value })
          }
        />
      </div>

      {/* Phone Number */}
      <h2 className="text-lg font-semibold mb-2 mt-6">Phone Number</h2>
      <div className="mt-2 rounded-md bg-white px-4 py-3 text-base text-gray-900 border border-gray-300 placeholder:text-gray-400 focus-within:border-violet-300 focus-within:ring-1 focus-within:ring-violet-300 sm:text-sm">
        <input
          type="tel"
          placeholder="Enter phone number"
          className="w-full focus:outline-none"
          value={manualDetails?.phone}
          onChange={(e) =>
            setManualDetails({ ...manualDetails, phone: e.target.value })
          }
        />
      </div>

      {/* Email Address */}
      <h2 className="text-lg font-semibold mb-2 mt-6">Email Address</h2>
      <div className="mt-2 rounded-md bg-white px-4 py-3 text-base text-gray-900 border border-gray-300 placeholder:text-gray-400 focus-within:border-violet-300 focus-within:ring-1 focus-within:ring-violet-300 sm:text-sm">
        <input
          type="email"
          placeholder="Enter email address"
          className="w-full focus:outline-none"
          value={manualDetails?.email}
          onChange={(e) =>
            setManualDetails({ ...manualDetails, email: e.target.value })
          }
        />
      </div>
    </div>
  )
}

export default GpAddressForm
